module.exports = [
  {
    cover: "https://m.media-amazon.com/images/I/51smhY+-94L.jpg",
    bookName: "The Ocean at the End of the Lane",
    author: "Neil Gaiman",
    narrator: "Erin Morgenstern",
    genre: "Magical Realism",
    link:
      "https://www.audible.in/pd/Thalia-Book-Club-Neil-Gaiman-The-Ocean-at-the-End-of-the-Lane-Audiobook/B079WYRZSZ?qid=1608198202&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=WNA2YJJVZ4EC97S3A3Q9"
  },
  {
    cover:
      "https://images-na.ssl-images-amazon.com/images/I/515eBkctNVL._SX334_BO1,204,203,200_.jpg",
    bookName: "True Grit",
    author: "Charles Portis",
    narrator: "Donna Tartt",
    genre: "Classic",
    link:
      "https://www.audible.in/pd/True-Grit-Audiobook/B079VTBLTH?qid=1608199064&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=GAJWNYNTGK686AA82FER"
  },
  {
    cover: "https://m.media-amazon.com/images/I/31YMgg0SVtL.jpg",
    bookName: "Digital Minimalism",
    author: "Cal Newport",
    narrator: "Will Damron",
    genre: "Self Development",
    link:
      "https://www.audible.in/pd/Digital-Minimalism-Audiobook/B07N12TVTS?qid=1608199270&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=768ZRCPNPX7KJCTBEBTF"
  },
  {
    cover:
      "https://images-na.ssl-images-amazon.com/images/I/51+kE0KESsL._SX326_BO1,204,203,200_.jpg",
    bookName: "And Then There Were None",
    author: "Agatha Christie",
    narrator: "Hugh Fraser",
    genre: "Mystery",
    link:
      "https://www.audible.in/pd/And-Then-There-Were-None-Audiobook/B07B7BB9MV?qid=1608199532&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=RX7C42FEVDDFZCD81EBG"
  },
  {
    cover: "https://m.media-amazon.com/images/I/41+S9fvRYfL.jpg",
    bookName: "Death on the Nile",
    author: "Agatha Christie",
    narrator: "Kenneth Branagh",
    genre: "Mystery",
    link:
      "https://www.audible.in/pd/Death-on-the-Nile-Audiobook/B086BFQMKR?qid=1608212109&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=2ZMG4GHTKPNZD2563B0Q"
  },
  {
    cover: "https://m.media-amazon.com/images/I/51UsBVKGASL._SX260_.jpg",
    bookName: "The Ickabog",
    author: "J.K. Rowling",
    narrator: "J.K. Rowling",
    genre: "Fantasy",
    link:
      "https://www.audible.in/pd/The-Ickabog-Audiobook/B08D9SLNKL?plink=Iy1YpebGhiLf1BYT&ref=a_pd_And-Th_c2_adblp13npsbx_1_5&pf_rd_p=a55f3f73-7c6c-4aac-8ad0-05045d19c470&pf_rd_r=84DMMD9RDP07159NQ8KW"
  },
  {
    cover: "https://m.media-amazon.com/images/I/51UoqRAxwEL.jpg",
    bookName: "Harry Potter and the Philosopher's Stone",
    author: "J.K. Rowling",
    narrator: "Stephen Fry",
    genre: "Fantasy",
    link:
      "https://www.audible.in/pd/Harry-Potter-and-the-Philosophers-Stone-Book-1-Audiobook/B072WB8YX9?source_code=+AUDOTH130031120004M&gclid=CjwKCAiAoOz-BRBdEiwAyuvA6xucMooMR4xtr8zw5IH8D1nWbekWaInCIE1C_Vft2k9vJiQLnY7nCxoCBYIQAvD_BwE"
  },
  {
    cover:
      "https://images-na.ssl-images-amazon.com/images/I/51bRB3n0QoL._SX307_BO1,204,203,200_.jpg",
    bookName: "Is Everyone Hanging Out Without Me?",
    author: "Mindy Kaling",
    narrator: "Mindy Kaling",
    genre: "Biography",
    link:
      "https://www.audible.in/pd/Is-Everyone-Hanging-Out-Without-Me-Audiobook/B079X2ZF3F?qid=1608199894&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=KBJVHEWRD3ACAG87FA0K"
  },
  {
    cover:
      "https://images-na.ssl-images-amazon.com/images/I/41+2kxHNPmL._SX336_BO1,204,203,200_.jpg",
    bookName: "The Diana Chronicles",
    author: "Tina Brown",
    narrator: "Tina Brown",
    genre: "Biography",
    link:
      "https://www.audible.in/pd/The-Diana-Chronicles-Audiobook/B079X33C54?qid=1608209830&sr=1-2&ref=a_search_c3_lProduct_1_2&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=2D2N65ZH3J8ZGY8M34X5"
  },
  {
    cover:
      "https://images-eu.ssl-images-amazon.com/images/I/51IW0v6Zb8L._SX342_SY445_QL70_ML2_.jpg",
    bookName: "Neverwhere",
    author: "Neil Gaiman",
    narrator: "Christopher Lee, James McAvoy",
    genre: "Horror",
    link:
      "https://www.audible.in/pd/Neverwhere-Adaptation-Audiobook/B07B61S62M?qid=1608211424&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=2J0RV3F9BVE856PQ0VKH"
  },
  {
    cover:
      "https://images-na.ssl-images-amazon.com/images/I/51UA4cTPAhL._SX321_BO1,204,203,200_.jpg",
    bookName: "The murder on orient express",
    author: "Agatha Christie",
    narrator: "Tom Conti, Jane Asher",
    genre: "Horror",
    link:
      "https://www.audible.in/pd/Murder-on-the-Orient-Express-Audiobook/B0771SJ626?qid=1608212651&sr=1-1&ref=a_search_c3_lProduct_1_1&pf_rd_p=2d02bc98-4366-4f94-99d9-5e898cda0766&pf_rd_r=XPJJSBWMMM5A9DE68PYD"
  }
];
